<template>
  <div class="rentals-list-w">

    <WorklistFilters :filterFormData="filterFormData" @filterInterface="updateFilterFormData" :appliedFilters="appliedFilters" v-show="toggleFilterState.display == 'Filters' && toggleFilterState.show == true" :filters="filters"/>
    <WorklistColumns @columnInterface="updateColumnFormData" v-show="toggleFilterState.display == 'Columns' && toggleFilterState.show == true" />

    <div class="rentals-list">
      <div class="list-controls">
        <div class="list-info export">
          <div class="btn-group mr-1 mb-1 mt-1">
            <button aria-expanded="false" aria-haspopup="true" class="btn btn-white dropdown-toggle export-button" data-toggle="dropdown" id="export-button" type="button">{{toggleState.display}}</button>
            <div aria-labelledby="export-button" class="dropdown-menu" x-placement="top-start">
              <a class="dropdown-item" @click="toggleFilters('Filters')"> Show Filters</a>
              <!-- <a class="dropdown-item" @click="toggleFilters('Columns')"> Columns</a> -->
              <a class="dropdown-item" @click="toggleFilters('Show Sidebar')" v-if="toggleFilterState.show == true"> Hide Filters</a>
            </div>
          </div>
        </div>
        <div class="list-info export">
          <div class="btn-group mr-1 mb-1 mt-1">
            <button aria-expanded="false" aria-haspopup="true" class="btn btn-white dropdown-toggle export-button" data-toggle="dropdown" id="export-button" type="button">Export</button>
            <div aria-labelledby="export-button" class="dropdown-menu" x-placement="top-start">
              <a class="dropdown-item" @click="exportReport('quick_download')"> Quick Download</a>
              <a class="dropdown-item" @click="exportReport('scoped')"> Export Filtered</a>
              <a class="dropdown-item" @click="exportReport('all')"> Export All</a>
            </div>
          </div>
        </div>
        <div class="list-search">
          <div class="input-search-w"><input class="form-control rounded bright" @input="isTyping = true" v-model="searchString" placeholder="Search worklist..." type="search"></div>
        </div>
        <div class="list-order">
          <label for="">Channel:</label>
          <select v-model="selectedChannel" @change="onChangeChannel" class="form-control-sm">
            <option v-for="channel in channels" :value="channel.id_channel">{{channel.channel_name}}</option>
          </select>
        </div>
        <div class="list-order">
          <label for="">Mode:</label>
          <select v-model="selectedMode" @change="onChangeMode" class="form-control-sm">
            <option value="Workflow">Workflow</option>
            <option value="RMS">RMS</option>
          </select>
        </div>
      </div>
      <div class="property-items as-grid">
        <Loader v-if="loadingWorklist && !errorWorklist" />
        <Error v-if="errorWorklist" />
        <ReportGrid />
        <!-- <WorklistTable :worklistdata="pagination" :worklistmovements="movements" :columns="[]" :searchString="searchString" :mode="selectedMode" v-else /> -->
      </div>
      <!-- <Pagination v-if="pagination.last_page >= 1 " :pagination="pagination" @paginate="onChangeMode()" :offset="5" :withWrapper="false"></Pagination> -->
    </div>

  </div>
</template>

<script>
import ReportGrid from '@/components/reportdesk/grid/ReportGrid'
import WorklistColumns from '@/components/reportdesk/WorklistColumns'
import WorklistFilters from '@/components/reportdesk/WorklistFilters'
import WorklistTable from '@/components/reportdesk/WorklistTable'
import Pagination from '@/components/common/Pagination'
import Loader from '@/components/common/Loader'
import Error from '@/components/common/Error'
import { debounce } from 'underscore'

export default {
  components: {
    ReportGrid,
    WorklistColumns,
    WorklistFilters,
    WorklistTable,
    Pagination,
    Loader,
    Error
  },
  data: function () {
    return {
      loadingWorklist: false,
      errorWorklist: false,
      toggleState: {
        show: false,
        display: 'Filters'
      },
      pagination: {
        current_page: 1
      },
      RMSpagination: {
        current_page: 1
      },
      movements: '',
      channels: '',
      appliedFilters: '',
      filterFormData: '',
      columnFormData: '',
      selectedChannel: '',
      selectedLocation: 'All',
      selectedMode: 'Workflow',
      searchString: '',
      isTyping: false,
      filters: {
        category: [],
        gender: [],
        brand: [],
        season: []
      }
    }
  },
  mounted: function () {
    this.getWorklistParams()
  },
  methods: {
    getWorklistParams () {
      var self = this

      const url = '/reportdesk/report/filter/helper'
      this.$http
        .post(url, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.channels = response.data.channels
          self.selectedChannel = self.channels[0].id_channel
          self.filters.category = response.data.categories
          self.filters.gender = response.data.genders
          self.filters.brand = response.data.brands
          self.filters.season = response.data.seasons
          self.getWorklistData()
        })
        .catch(function (error) {
          console.log(error)
          self.$store.dispatch('updateToast', {
            text: 'Error fetching worklist boot params',
            show: true
          })
        })
    },

    updateColumnFormData (data) {
      this.columnFormData = data
    },
    updateFilterFormData (data) {
      this.filterFormData = data
      this.getWorklistData()
    },
    getWorklistData: function () {
      var self = this
      var search =
        this.searchString != '' ? '&search=' + this.searchString : ''
      var data = this.filterFormData != '' ? this.filterFormData : ''
      if (search != '' || data != '') this.pagination.current_page = 1
      const url =
        '/reportdesk/report/worklist?page=' +
        this.pagination.current_page +
        '&channel=' +
        this.selectedChannel +
        '&location=' +
        this.selectedLocation +
        search

      this.loadingWorklist = true
      this.errorWorklist = false

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          console.log(response)
          self.pagination = response.data.products
          self.movements = response.data.movements
          self.appliedFilters = response.data.filters
          self.loadingWorklist = false
        })
        .catch(function (error) {
          self.loadingWorklist = false
          self.errorWorklist = true
        })
    },

    getRMSData: function () {
      var self = this
      var search =
        this.searchString != '' ? '&search=' + this.searchString : ''
      var data = this.filterFormData != '' ? this.filterFormData : ''
      if (search != '' || data != '') this.pagination.current_page = 1
      const url =
        '/reportdesk/report/rms?page=' +
        this.pagination.current_page +
        '&channel=' +
        this.selectedChannel +
        '&location=' +
        this.selectedLocation +
        search

      this.loadingWorklist = true
      this.errorWorklist = false

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          console.log(response)
          self.pagination = response.data.products
          self.loadingWorklist = false
        })
        .catch(function (error) {
          self.loadingWorklist = false
          self.errorWorklist = true
        })
    },

    exportReport (scope) {
      console.log(scope)
      var self = this
      var search =
        this.searchString != '' ? '&search=' + this.searchString : ''
      var data =
        this.filterFormData != '' ? this.filterFormData : new FormData()
      if (scope == 'scoped') {
        var url =
          '/reportdesk/report/worklist?page=' +
          this.pagination.current_page +
          '&channel=' +
          this.selectedChannel +
          '&location=' +
          this.selectedLocation +
          search
        data.append('is_export_scoped', 1)
      } else {
        var url = '/reportdesk/report/worklist?channel=' + this.selectedChannel
        data.append('is_export', 1)
      }

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          console.log(response)
          self.$store.dispatch('updateToast', {
            text: 'Export Requested',
            show: true
          })
          self.$router.push('/reportdesk/reports/exported')
        })
        .catch(function (error) {
          console.log(error)
          self.$store.dispatch('showToastAPIError')
        })
    },
    toggleFilters: function (type) {
      this.toggleState.display = type
      this.toggleState.show = type != 'Show Sidebar'
    },
    onChangeChannel: function () {
      this.getWorklistData()
    },
    onChangeMode: function () {
      if (this.selectedMode == 'RMS') {
        this.getRMSData()
      } else {
        this.getWorklistData()
      }
    }
  },
  computed: {
    toggleFilterState () {
      return this.toggleState
    },
    searchTyping () {
      return this.isTyping
    }
    // isTyping: function(value) {
    //   if (!value) {
    //     this.getWorklistData();
    //   }
    // }
  },
  watch: {
    columnFormData (val, oldVal) {},
    toastSettings (val, oldval) {},
    loadingWorklist () {
      return this.loadingWorklist
    },
    errorWorklist () {
      return this.errorWorklist
    },
    toggleState () {
      if (this.toggleState.show == false) {
        $('.rentals-list-w').toggleClass('hide-filters')
      }
    },
    searchTyping: debounce(function () {
      this.isTyping = false
      this.onChangeMode()
    }, 1000)
  }
}
</script>

<style scoped>
.rentals-list-w .rentals-list .list-controls .list-order:last-child {
  margin-left: 10px;
}
.export {
  margin-left: 10px;
}
.export-button {
  color: rgba(0, 0, 0, 0.8);
  font-size: 0.72rem;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 1px;
  font-size: 0.72rem;
}
.btn-white:hover,
.btn-white:active,
.btn-white:focus,
.btn-white:visited {
  background-color: #ffffff;
  border: 1px solid #ddd;
  color: rgba(0, 0, 0, 0.4);
}
.btn-white,
.all-wrapper .fc-button {
  border: 1px solid #ddd;
}
.list-search {
  margin-left: auto;
}
.property-items {
  height: calc(100vh - 150px);
}
.rentals-list-w {
  display: flex;
  /* overflow: hidden; */
  height: calc(100vh - 54px);
  position: relative;
}

.filters-toggle {
  color: rgb(31, 97, 234) !important;
  cursor: pointer;
}

.rentals-list-w .rentals-list {
  width: 0vw !important;
}
.rentals-list-w .property-items.as-grid {
  overflow: scroll;
}
.form-control-sm {
  height: 25px;
}
</style>
